import React from 'react';
import {
  IconButton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  useToast,
  TableCaption,
} from '@chakra-ui/react';
import { CopyIcon } from '@chakra-ui/icons';

import {
  copyQuoteTable,
  priceForCell,
  QuoteMatrixProps,
  QuoteValueSelector,
  sampleSizeLabel,
} from './utils';

const recruitmentCostSelector: QuoteValueSelector = (q) =>
  q.subtotals.recruitment_cost;

export default function RecruitmentCostSection(props: QuoteMatrixProps) {
  const {
    numberOfQuestions,
    sampleSizes,
    quotes,
    calculatedMaxRecommendedSampleSize,
  } = props;

  const toast = useToast();

  const handleCopy = async () => {
    try {
      await copyQuoteTable(props, recruitmentCostSelector);
      toast({
        title: 'Estimated Recruitment Costs',
        description: 'Copy estimated recruitment costs to clipboard!',
        status: 'info',
        duration: 5000,
        isClosable: true,
      });
    } catch {
      toast({
        title: 'Estimated Recruitment Costs',
        description:
          'Could not copy the estimated recruitment costs to your clipboard.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <TableContainer>
      <Table variant="striped" size="sm">
        <TableCaption
          placement="top"
          backgroundColor="brand.tableTitleColor"
          textColor="brand.bodyText"
          fontSize="lg"
        >
          Estimated Recruitment Cost
          <IconButton
            aria-label="Copy estimated recruitment costs to clipboard"
            variant="ghost"
            color="brand.linkColor"
            marginLeft={10}
            onClick={handleCopy}
          >
            <CopyIcon />
          </IconButton>
        </TableCaption>
        <Thead>
          <Tr>
            <Td textAlign="center" fontWeight="bold">
              Respondents
            </Td>
            {sampleSizes.map((value) => (
              <Td textAlign="center" fontWeight="bold" key={value}>
                {sampleSizeLabel(value)}
              </Td>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {numberOfQuestions.map((questionCount) => (
            <Tr key={questionCount}>
              <Td textAlign="center">
                <strong>{questionCount} Question Poll</strong>
              </Td>
              {sampleSizes.map((sampleValue) => (
                <Td
                  textAlign="center"
                  key={`${questionCount}-${sampleValue}`}
                  color={
                    sampleValue > calculatedMaxRecommendedSampleSize
                      ? 'emphasisTextColor'
                      : 'current'
                  }
                >
                  {priceForCell(
                    quotes,
                    questionCount,
                    sampleValue,
                    recruitmentCostSelector,
                  )}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
